import { SidebarTrigger } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { Menu, Bell, Waves } from "lucide-react";
import { AuthStatus } from "./AuthStatus";

export function MobileHeader() {
    return (
        <header className="sticky top-0 z-30 flex h-16 items-center justify-between gap-3 border-b border-border/60 bg-background/95 backdrop-blur-lg px-4 shadow-loch md:hidden">
          {/* Menu & Logo Section */}
          <div className="flex items-center gap-3">
            <SidebarTrigger className="touch-target transition-smooth-fast hover:bg-primary/10 rounded-lg">
              <Menu className="h-6 w-6 text-primary" />
            </SidebarTrigger>

            {/* App Logo */}
            <div className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary to-accent shadow-loch">
                <Waves className="h-5 w-5 text-white" />
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-sm font-bold text-foreground">Loch & Lunge</span>
                <span className="text-[10px] text-muted-foreground">Wild Swimming</span>
              </div>
            </div>
          </div>

          {/* Actions Section */}
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              className="relative touch-target transition-smooth-fast hover:bg-primary/10 hover:text-primary"
            >
              <Bell className="h-5 w-5" />
              <span className="absolute top-1.5 right-1.5 flex h-4 w-4">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent/75"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-accent text-white text-[10px] font-bold items-center justify-center shadow-sm">
                  5
                </span>
              </span>
            </Button>
            <AuthStatus />
          </div>
        </header>
    )
}
